
var st;
var headerCTA;

function refreshCart(){
  $.ajax({
    url : '/cart.js',
    type : 'GET',
    dataType: 'json',
    success: function(cart){
      $(".global-cart-count").html(cart.item_count);
    }
  });
}

function evenHeight(){

	if ($(window).width() >= 960){
		$(".global-watch-popup-content").each(function(){
			var max = 0;
			$(this).find(".header-nav-sub-each-header").each(function(){
				if($(this).outerHeight() > max)
				{
					max = $(this).outerHeight();
					//console.log(max + "max");
				}
			}).css("height",max);
		});
	}
	else{
		$(".header-nav-sub-each-header").css("height", "");
	}
}

function preventDefault(e) {
	e = e || window.event;
	if (e.preventDefault)
		e.preventDefault();
	e.returnValue = false;  
}


var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefaultForScrollKeys(e) {
	if (keys[e.keyCode]) {
		preventDefault(e);
		return false;
	}
}

function disableScroll() {
        if (window.addEventListener) // older FF
        	window.addEventListener('DOMMouseScroll', preventDefault, false);
        window.onwheel = preventDefault; 
        window.onmousewheel = document.onmousewheel = preventDefault; 
        window.ontouchmove  = preventDefault; 
        document.onkeydown  = preventDefaultForScrollKeys;
      }

      function enableScroll() {
       if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
      window.onmousewheel = document.onmousewheel = null; 
      window.onwheel = null; 
      window.ontouchmove = null;  
      document.onkeydown = null;  
    }


    function headerFixed(){

    	if ($(window).width() >= 768){
    		if ($("header").hasClass("header-fixed")){
    			$(".global-content-con").css({
    				"margin-top" : $(".header-nav-con").outerHeight()
    			});
    		}
    		else{
    			$(".global-content-con").css({
    				"margin-top" : "" 
    			});
    		}

    		$(".header-search-con").css({
    			"top" : ""
    		});

    	}
    	else{

    		$(".global-content-con").css({
    			"margin-top" : "" 
    		});
    	}

    }

    function headerNav(){

    	if (ww < 960){

    		$(".header-nav, .header-nav-sub-con").css({
    			"padding-top" : hh,
    		});


    	}
    	else{
    		$(".header-nav, .header-nav-sub-con").css({
    			"height" : ""
    		});
    	}
    }


    function resizeFunction(){
    	ww = $(window).width();
    	wh = $(window).height();
    	hh = $("header").outerHeight();
      bh = $(".global-banner-con").outerHeight();


      if (ww >= 960){
        $(".header-nav-sub-con").css({
         "width" : $("header").outerWidth()
       });


        $(".header-cart-header-total").css({
          "padding-top" : ($(".header-cart-con-left").outerHeight() - $(".header-cart-header-total").outerHeight()) / 2
        });
      }
      else{
        $(".header-nav-sub-con").css({
         "width" : "",
    			//"top" : ""
    		});
      }

    }


    $(window).on("resize",function(){
     resizeFunction();
     headerNav();
     evenHeight();
   });

    $(window).on("load",function(){
     resizeFunction();
     headerNav();


     headerCTA = ($(".header-fixed-cta").outerWidth() + parseInt($(".header-fixed-cta").css("margin-left")));

     if (ww >= 960){
      $(".header-nav-sub-con").css({
        "top" : hh 
      });

      $(".header-cart-items-img").css({
        "height" : $(".header-cart-items-img").outerWidth()
      });

      evenHeight();

    }
    else{
      $(".header-msg-con").css({
        "top" : hh
      });
    }

    if ($(window).scrollTop() > bh){
      $("header").addClass("fixed");

      if (ww >= 960){
        $(".header-nav-sub-con, .header-msg-con").css({
          "top" : $("header.fixed").outerHeight()
        });
      }
    }

    $(".global-watch-popup-tabs-each").first().trigger("click");

  });

    $(window).on("scroll mousewheel",function(){

      st = $(window).scrollTop();

      if ($(window).width() >= 960){


        if ( st >= bh) {

          if (!$(".global-banner-con").hasClass("index-banner-con")){
            $("header").addClass("fixed");

            $(".header-nav-sub-con, .header-msg-con").css({
              "top" : $("header.fixed").outerHeight()
            });
          }
          
        }
        else{
          $("header").removeClass("fixed");

          $(".header-nav-sub-con").css({
            "top" : hh 
          });

        }
      }
      else{
        if (st > bh){
          $("header").addClass("fixed");
        }
        else{
          $("header").removeClass("fixed");
        }
      }


    });


    $(".header-nav-parent").hover(

     function(e){
      if (ww >= 1150){
   // $(this).find(".header-nav-sub-con").addClass("active");
   $(this).addClass("active");
   $(this).find(".header-nav-sub-con").animate({opacity: 1},300);
  // console.log($(this).outerHeight());
}
},
function(e){
  if (ww >= 1150){
   // $(this).find(".header-nav-sub-con").removeClass("active");
   $(this).find(".header-nav-sub-con").animate({opacity: 0},300);
   
   $(this).removeClass("active");
   
 }
}

);

    $(".global-watch-hover").hover(
     function(e){
      if (ww >= 960){
       $(this).addClass("active");
       $(this).parent().find(".global-watch-hover:not(.active)").css({
        "opacity": 0.5
      });
     }
   },
   function(e){
    if (ww >= 960){
     $(this).removeClass("active");
     $(this).parent().find(".global-watch-hover:not(.active)").css({
      "opacity": ""
    });
   }
 }
 );

    $(".global-watch-popup-tabs-each").on("click",function(){


      t = $(this);
      thisId = t.attr("data-id");
      thisPanel = $("#" + thisId);
      popUp = $("#global-watch-popup3");
      console.log(thisPanel);


      popUp.find(".active").removeClass("active");
      t.addClass("active");
      console.log("tttt === " + t);

      setTimeout(function(){
        thisPanel.addClass("active");
      },200);


    });

// josh testing mobile popup



    $(".header-shortcut").on("click",function(){
     $(".header-nav").toggleClass("open");
     $(".header-nav-sub-con").removeClass("active");

     if ($(".header-nav").hasClass("open") && (ww < 960)){
      disableScroll();
    }
    else{
      enableScroll();
    }
  });


    $(".header-nav-cart").on("click",function(event){
      if (ww >= 960){
       event.preventDefault();

       if ($(this).hasClass("open")){
        $("header").css({
          "background-color" : ""
        });

        $(this).removeClass("open");
        $(".global-overlay").removeClass("open");

        $("header").css({
          "top" : ""
        });

        $(".header-nav-sub-con").css({
          "top" : hh 
        });

        $(".header-cart-con").find(".container").css({
          "opacity" : ""
        });

        enableScroll();
      }
      else{
        disableScroll();

        $("header").css({
//           "background-color" : "#222831"
          "background-color" : "#FFFFFF"
        });

        if ($(".header-msg-con").hasClass("show")){
          $(".header-msg-con").removeClass("show");
        }

        $(this).addClass("open");
        $(".global-overlay").addClass("open");

        $("header").css({
          "top" : $(".header-cart-con").outerHeight()
        });

        $(".header-nav-sub-con").css({
          "top" : hh + $(".header-cart-con").outerHeight()
        });

    //*For animation sake*//
    setTimeout(function(){
      $(".header-cart-con").find(".container").css({
        "opacity" : "1"
      });
    },400);

  }

} 
});

$(".global-overlay").on("click",function(){
  enableScroll();

  if ($(".header-nav-cart").hasClass("open")){

   $(".header-nav-cart").removeClass("open");
   
   $("header").css({
//     "background-color" : "",
    "background-color" : "#FFFFFF",
    "top" : ""
  });

   $(".header-nav-sub-con").css({
    "top" : hh 
  });


   $(".header-cart-con").find(".container").css({
    "opacity" : ""
  });

   $(this).removeClass("open");

 }

});



$(document).ready(function() {
 $('.build-watch-trigger').magnificPopup({
  type: 'inline',
  preloader: false,
  closeBtnInside: false,
  closeOnBgClick: true,
  closeOnContentClick: false,
  removalDelay: 300,
  callbacks:{
    open: function(){

      console.log("open");

      if (ww >= 960)
      { 
        $("#global-watch-popup").find(".header-nav-sub-each").each(function(){
         var max = 0;
         $(this).find(".header-nav-sub-each-header").each(function(){
           if($(this).outerHeight() > max)
           {
             max = $(this).outerHeight();
             console.log(max+"max")
           }
         }).css("height",max);
       });
      }
      else{
        $("#global-watch-popup").find(".global-watch-popup-content").each(function(){
         var max = 0;
         $(this).find(".header-nav-sub-each").each(function(){
           if($(this).outerHeight() > max)
           {
             max = $(this).outerHeight();
             $(".global-watch-popup-content").css("height" , max);
           }
         });
       });
      }
    }
  }
});
});

$(document).ready(function() {
 $('.build-watch-trigger2').magnificPopup({
  type: 'inline',
  preloader: false,
  closeBtnInside: false,
  closeOnBgClick: true,
  closeOnContentClick: false,
  removalDelay: 300,
  callbacks:{
    open: function(){

      console.log("open");

      if (ww >= 960)
      { 
        $("#global-watch-popup3").find(".header-nav-sub-each").each(function(){
         var max = 0;
         $(this).find(".header-nav-sub-each-header").each(function(){
           if($(this).outerHeight() > max)
           {
             max = $(this).outerHeight();
             console.log(max+"max")
           }
         }).css("height",max);
       });
      }
      else{
        $("#global-watch-popup3").find(".global-watch-popup-content").each(function(){
         var max = 0;
         $(this).find(".header-nav-sub-each").each(function(){
           if($(this).outerHeight() > max)
           {
             max = $(this).outerHeight();
             $(".global-watch-popup-content").css("height" , max);
           }
         });
       });
      }
    }
  }
});
});

$(document).ready(function() {
 $('.build-watch').magnificPopup({
  type: 'inline',
  preloader: false,
  closeBtnInside: false,
  closeOnBgClick: true,
  closeOnContentClick: false,
  removalDelay: 300,
  callbacks:{
    open: function(){

      console.log("open");

      if (ww >= 960)
      { 
        $("#global-watch-popup").find(".header-nav-sub-each").each(function(){
         var max = 0;
         $(this).find(".header-nav-sub-each-header").each(function(){
           if($(this).outerHeight() > max)
           {
             max = $(this).outerHeight();
             console.log(max+"max")
           }
         }).css("height",max);
       });
      }
      else{
        $("#global-watch-popup").find(".global-watch-popup-content").each(function(){
         var max = 0;
         $(this).find(".header-nav-sub-each").each(function(){
           if($(this).outerHeight() > max)
           {
             max = $(this).outerHeight();
             $(".global-watch-popup-content").css("height" , max);
           }
         });
       });
      }
    }
  }
});
});

$(document).ready(function() {
 $('.build-watch2').magnificPopup({
  type: 'inline',
  preloader: false,
  closeBtnInside: false,
  closeOnBgClick: true,
  closeOnContentClick: false,
  removalDelay: 300,
  callbacks:{
    open: function(){

      console.log("open");

      if (ww >= 960)
      { 
        $("#global-watch-popup2").find(".header-nav-sub-each").each(function(){
         var max = 0;
          console.log("test");
         $(this).find(".header-nav-sub-each-header").each(function(){
           if($(this).outerHeight() > max)
           {
             max = $(this).outerHeight();
             console.log(max+"max")
           }
         }).css("height",max);
       });
      }
      else{
        $("#global-watch-popup2").find(".global-watch-popup-content").each(function(){
         var max = 0;
          
          console.log("test2");
         $(this).find(".header-nav-sub-each").each(function(){
           if($(this).outerHeight() > max)
           {
             max = $(this).outerHeight();
             console.log("max == " + max);
             $(".global-watch-popup-content").css("height" , max);
             $(".global-watch-popup-tabs-each").first().trigger("click");
           }
         });
       });
      }
    }
  }
});
});